import React from 'react'

import CreationInvitationHeader from 'components/common/CreationInvitationHeader'

type CreateAttackHeadProps = {
  origin: string
}

const CreateAttackHead: React.FC<CreateAttackHeadProps> = ({ origin = '' }) => (
  <CreationInvitationHeader
    buttonText="New Attack"
    heading="Create a new attack."
    link={`/attacks/new/${origin ?? ''}`}
    subheading="An attack is a way of creating or injecting stress and/or failure in some part of a system, such as causing networking problems or exhausting resources up to their limits. This is also known as fault injection. Attacks are the means by which we perform Chaos Engineering, and how we identify failure modes in systems."
  />
)

export default CreateAttackHead
